export default __webpack_public_path__ + "static/media/img7.18111521.jpg";